/**
 * CopyCellStrip
 *
 * The Observatory Split hairline strip (LUM-155 storyboard): titled cells
 * between two hairlines, separated by hairline rules. Renders structured
 * ux_copy (LUM-158) — the pre-call practicalities and the completion
 * next steps.
 */

import { Box, Group, Text } from '@mantine/core';
import type { CopyCell } from '@/types/ux-copy';

const STRIP_BORDER = '1px solid rgba(29, 36, 50, 0.16)';

export interface CopyCellStripProps {
  /** Accessible name of the list (e.g. "Practicalities"). */
  label: string;
  cells: readonly CopyCell[];
}

export function CopyCellStrip({ label, cells }: Readonly<CopyCellStripProps>) {
  return (
    <Group
      component="ul"
      aria-label={label}
      gap={0}
      grow
      align="flex-start"
      style={{
        borderTop: STRIP_BORDER,
        borderBottom: STRIP_BORDER,
        padding: '13px 0',
        margin: 0,
        listStyle: 'none',
      }}
    >
      {cells.map((cell, index) => (
        <Box
          component="li"
          key={`${cell.title}|${cell.detail}`}
          pl={index === 0 ? 0 : 16}
          pr={index === cells.length - 1 ? 0 : 16}
          style={index === 0 ? undefined : { borderLeft: STRIP_BORDER }}
        >
          <Text fz={13} fw={600}>
            {cell.title}
          </Text>
          <Text fz={12} c="navy.6" lh={1.45}>
            {cell.detail}
          </Text>
        </Box>
      ))}
    </Group>
  );
}
